// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"647a54a3","703":"8c242435"}[chunkId] + ".chunk.js";
};